import {Component, OnInit, ViewChild} from '@angular/core';
import {ServiceSubject} from '../../../Models/ServiceSubject';
import {UntypedFormGroup} from '@angular/forms';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {TranslateService} from '@ngx-translate/core';
import {ServiceSubjectService} from '../../../Services/service-subject.service';
import {environment} from '../../../../../environments/environment';
import {SolutionService} from '../../../Services/solution.service';
import {Solution} from '../../../Models/Solution';

@Component({
  selector: 'app-manage-solution',
  templateUrl: './manage-solution.component.html',
  styleUrls: ['./manage-solution.component.scss']
})
export class ManageSolutionComponent implements OnInit {

  public solution: Solution = new Solution();
  public classicBox;
  public lastValue = <any>{};
  public enableSave = true;
  form = new UntypedFormGroup({});
  public solutionId: number;
  public isEdit = false;
  options: FormlyFormOptions = {};
  @ViewChild('classicForm', {static: false}) child;
  private isDone = true;
  public subjects = [];
  public subjectId = null;

  constructor(
    private route: ActivatedRoute,
    public helper: Helper,
    private translate: TranslateService,
    private solutionService: SolutionService,
    private serviceSubjectService: ServiceSubjectService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['subjectId'])) {
        this.subjectId = +params['subjectId'];
        this.lastValue = {solution: {serviceSubjects: [this.subjectId]}};
      }
      if (Helper.isDefined(params['id'])) {
        this.solutionId = params['id'];
        this.isEdit = true;
        this.solutionService.getSolution(this.solutionId).subscribe(resp => {
          resp.status = +resp.status;
          const subjects = [];
          for (const serviceSubject of resp.serviceSubjects) {
            subjects.push(serviceSubject.id);
          }
          resp.serviceSubjects = subjects;
          this.lastValue = {solution: resp};
        });
      }
    });

    this.serviceSubjectService.list().subscribe(subjects => {
      subjects.data.map((value) => {
        this.subjects.push({
          label: value.name,
          value: value.id
        });
      });
      this.classicBox = <FormlyFieldConfig>[
        {
          fieldGroupClassName: 'row',
          key: 'solution',
          fieldGroup: [
            {
              className: 'col-6 ',
              type: 'input',
              key: 'name',
              templateOptions: {
                label: this.translate.instant('doctrine.solution.name'),
                required: true,
                maxLength: environment.maxStringLength,
              },
              validation: {
                messages: {
                  pattern: this.translate.instant('errors.invalid'),
                  required: this.translate.instant('errors.required'),
                  maxlength: (error, field: FormlyFieldConfig) =>
                    this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                },
              },
            },
            {
              key: 'status',
              type: 'ng-select',
              className: 'col-6',
              templateOptions: {
                multiple: false,
                label: this.translate.instant('global.status'),
                required: true,
                options: [{label: this.translate.instant('global.active'), value: 1}, {
                  label: this.translate.instant('global.inactive'),
                  value: 0
                }]
              },
            },
          ],
        },
        {
          className: 'section-label',
          template: '<div><strong>' + this.translate.instant('admin.solution.subject') + '</strong></div><hr />',
        },
        {
          fieldGroupClassName: 'row mb-3',
          key: 'solution',
          fieldGroup: [
            {
              key: 'serviceSubjects',
              type: 'ng-select',
              className: 'col-6 ',
              templateOptions: {
                multiple: true,
                label: this.translate.instant('doctrine.solution.subjects'),
                required: true,
                options: this.subjects
              }
            }
          ],
        }
      ];
    });
  }

  public enableButton(event) {
    this.enableSave = event;
  }

  public submitItem(next: boolean) {
    if (next) {
      const solution = this.lastValue.solution;

      this.solutionService.manageSolution({
        solution: {
          name: solution.name,
          serviceSubjects: solution.serviceSubjects,
          status: solution.status
        }
      }, this.isEdit, this.solutionId).subscribe((resp) => {
        this.router.navigateByUrl(
          this.subjectId ? '/back-office/service/subject/' + this.subjectId + '/show' : '/back-office/service/solution/overview'
        );
      });
    } else {
      this.router.navigateByUrl(
        this.subjectId ? '/back-office/service/subject/' + this.subjectId + '/show' : '/back-office/service/solution/overview'
      );
    }
  }

}
